module.exports = __webpack_public_path__ + "img/daycohost-tecnologicagente.ad299dfd.svg";